var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkpoolinline = function SvgLinkpoolinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 50,
    fill: "none",
    viewBox: "0 0 231 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkpool_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linkpool_inline_svg__b)",
    d: "M30.89 49.982v-4.064c-15.345 0-26.827-4.982-26.827-9.445H0c.018 7.7 13.281 13.509 30.89 13.509"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linkpool_inline_svg__c)",
    d: "M30.89 27.027c17.608 0 30.88-5.809 30.88-13.509l-1.845-.063-2.2.063c0 4.464-11.463 9.446-26.826 9.446l-.118 2.063.118 2h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linkpool_inline_svg__d)",
    d: "m.018 36.473 2.227.045 1.818-.045c0-4.464 11.464-9.446 26.827-9.446v-4.063c-17.609 0-30.872 5.8-30.872 13.509Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linkpool_inline_svg__e)",
    d: "M57.716 13.51h4.063C61.78 5.81 48.5 0 30.9 0v4.064c15.326 0 26.808 4.981 26.808 9.445h.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9385",
    d: "M8.163 22.836c1.8-.809 3.836-1.509 6.082-2.09C7.963 18.882 4.063 16.1 4.063 13.5c0-4.464 11.464-9.445 26.827-9.445l.2-1.973L30.89 0C13.28 0 .018 5.81.018 13.51c0 3.68 3.046 6.935 8.145 9.326M53.634 27.146c-1.8.809-3.836 1.509-6.081 2.09 6.281 1.864 10.181 4.646 10.181 7.246 0 4.464-11.463 9.445-26.826 9.445l-.073 2.082.073 1.991c17.608 0 30.88-5.809 30.88-13.509 0-3.7-3.054-6.936-8.145-9.336l-.009-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBB294",
    d: "M84.415 35.19V7.265h3.609v27.918h-3.61v.009M96.714 11.409c-.7 0-1.281-.227-1.745-.682-.464-.454-.7-1-.7-1.654 0-.655.227-1.246.7-1.691.464-.455 1.045-.682 1.745-.682.7 0 1.282.218 1.746.654.463.437.7.982.7 1.637 0 .654-.227 1.245-.682 1.709-.455.464-1.045.7-1.773.7l.01.009m-1.809 23.782V15.245h3.61v19.946h-3.61M116.059 15.054c1.627 0 3.064.319 4.309.937 1.245.627 2.209 1.582 2.918 2.863.7 1.282 1.055 2.9 1.055 4.855v11.473h-3.609V24.118c0-1.927-.473-3.39-1.409-4.364-.937-.972-2.264-1.463-3.973-1.463-1.282 0-2.4.254-3.345.754a5.13 5.13 0 0 0-2.2 2.218c-.518.982-.773 2.191-.773 3.646v10.273h-3.609V15.236h3.464v5.382l-.564-1.427c.655-1.3 1.655-2.318 3.009-3.046 1.355-.727 2.936-1.09 4.745-1.09h-.018M131.031 35.19V7.265h3.609v27.918h-3.609v.009m2.936-4.817.073-4.628 11.473-10.5h4.363l-8.809 8.655-1.954 1.655-5.155 4.818h.009m12.3 4.818-7.827-9.71 2.336-2.9 9.936 12.61h-4.445M153.948 42.49V15.246h3.464v5.382l-.227 4.627.372 4.628V42.49h-3.609m10.573-7.072c-1.655 0-3.164-.382-4.536-1.145-1.364-.764-2.455-1.9-3.273-3.41-.818-1.509-1.227-3.39-1.227-5.645 0-2.254.4-4.136 1.182-5.645.781-1.51 1.872-2.637 3.236-3.391 1.363-.755 2.9-1.128 4.609-1.128 1.954 0 3.69.428 5.19 1.282a9.385 9.385 0 0 1 3.573 3.555c.873 1.518 1.318 3.29 1.318 5.327 0 2.036-.436 3.81-1.318 5.346-.882 1.527-2.073 2.718-3.573 3.572-1.509.855-3.236 1.282-5.19 1.282h.009m-.3-3.164c1.282 0 2.427-.29 3.445-.863 1.018-.573 1.818-1.4 2.409-2.464.591-1.064.882-2.3.882-3.709 0-1.409-.291-2.664-.882-3.709a6.308 6.308 0 0 0-2.409-2.427c-1.018-.573-2.163-.864-3.445-.864s-2.391.291-3.409.864a6.308 6.308 0 0 0-2.409 2.427c-.591 1.045-.882 2.273-.882 3.71 0 1.435.291 2.635.882 3.708.591 1.064 1.391 1.891 2.409 2.464 1.018.582 2.154.863 3.409.863M188.147 35.418c-2.009 0-3.791-.436-5.345-1.318a9.88 9.88 0 0 1-3.691-3.627c-.9-1.546-1.354-3.291-1.354-5.246 0-1.954.454-3.736 1.354-5.263a9.654 9.654 0 0 1 3.691-3.591c1.554-.864 3.336-1.3 5.345-1.3s3.755.436 5.327 1.3c1.564.863 2.8 2.054 3.691 3.572.891 1.519 1.336 3.282 1.336 5.291 0 2.01-.445 3.737-1.336 5.264a9.579 9.579 0 0 1-3.691 3.61c-1.563.88-3.345 1.317-5.327 1.317v-.009m0-3.163c1.282 0 2.427-.291 3.446-.864 1.018-.573 1.809-1.4 2.39-2.464.573-1.063.864-2.3.864-3.709 0-1.409-.291-2.663-.864-3.709a6.136 6.136 0 0 0-2.39-2.427c-1.019-.573-2.164-.864-3.446-.864s-2.418.291-3.427.864a6.5 6.5 0 0 0-2.409 2.427c-.6 1.046-.9 2.273-.9 3.71 0 1.436.3 2.636.9 3.708.6 1.064 1.4 1.891 2.409 2.464 1 .582 2.145.864 3.427.864M212.037 35.418c-2.009 0-3.791-.436-5.345-1.318a9.88 9.88 0 0 1-3.691-3.627c-.9-1.546-1.354-3.291-1.354-5.246 0-1.954.454-3.736 1.354-5.263a9.654 9.654 0 0 1 3.691-3.591c1.554-.864 3.336-1.3 5.345-1.3s3.755.436 5.327 1.3c1.564.863 2.8 2.054 3.691 3.572.891 1.519 1.336 3.282 1.336 5.291 0 2.01-.445 3.737-1.336 5.264a9.579 9.579 0 0 1-3.691 3.61c-1.563.88-3.345 1.317-5.327 1.317v-.009m0-3.163c1.282 0 2.427-.291 3.446-.864 1.018-.573 1.809-1.4 2.39-2.464.573-1.063.864-2.3.864-3.709 0-1.409-.291-2.663-.864-3.709a6.136 6.136 0 0 0-2.39-2.427c-1.019-.573-2.164-.864-3.446-.864s-2.418.291-3.427.864a6.5 6.5 0 0 0-2.409 2.427c-.6 1.046-.9 2.273-.9 3.71 0 1.436.3 2.636.9 3.708.6 1.064 1.4 1.891 2.409 2.464 1 .582 2.145.864 3.427.864M227.391 35.19V7.265H231v27.918h-3.609v.009"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkpool_inline_svg__b",
    x1: 5.673,
    x2: 22.663,
    y1: 38.364,
    y2: 47.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B9385"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkpool_inline_svg__c",
    x1: 58.87,
    x2: 31.898,
    y1: 13.673,
    y2: 28.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CBB294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E8D7C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkpool_inline_svg__d",
    x1: 1.173,
    x2: 30.017,
    y1: 34.054,
    y2: 23.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#CBB294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E8D7C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkpool_inline_svg__e",
    x1: 57.789,
    x2: 28.989,
    y1: 10.082,
    y2: -1.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6B9385"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "linkpool_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h231v50H0z"
  })))));
};
export default SvgLinkpoolinline;